import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

class AdvModal extends React.Component {
  static setAppElement(element) {
    Modal.setAppElement(element);
  }

  componentDidUpdate(prevProps) {
    const { isOpen, bodyClass, htmlClass } = this.props;
    const { isOpen: wasOpen } = prevProps;

    const isModalOpen = isOpen;
    const isModalClose = !isOpen && wasOpen;

    if (isModalOpen && bodyClass) {
      document.body.classList.add(bodyClass);
      document.getElementsByTagName('html')[0].classList.add(htmlClass);
    } else if (isModalClose && bodyClass) {
      document.body.classList.remove(bodyClass);
      document.getElementsByTagName('html')[0].classList.remove(htmlClass);
    }
  }

  render() {
    setTimeout(() => {
      // Modal will continue to steal focus on any non-direct descendent of an input unless
      // we remove the tabindex from its root
      const modalContent = document.querySelector('.ReactModal__Content');

      if (modalContent) {
        modalContent.removeAttribute('tabindex');
      }
    }, 0);

    const { children, hasCloseButton, onRequestClose } = this.props;

    return (
      <Modal parentSelector={() => document.getElementById('modals')} {...this.props}>
        {hasCloseButton && (
          <button type="button" className="fa fa-times close-button" onClick={onRequestClose} />
        )}

        {children}
      </Modal>
    );
  }
}

AdvModal.defaultProps = {
  children: null,
  hasCloseButton: false,
  shouldCloseOnOverlayClick: false,
  onRequestClose: () => {},
};

AdvModal.propTypes = {
  children: PropTypes.node,
  hasCloseButton: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default AdvModal;
